// neurotrader-admin/src/pages/BotStatsPage.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from '../context/AuthContext';
import StatCard from '../components/StatCard'; // Reutilizamos nosso StatCard!
import { toast } from 'react-toastify';
import { FiRepeat, FiDollarSign, FiUsers, FiTarget } from 'react-icons/fi';
import './AdminDashboardPage.css'; // Reutiliza o CSS do dashboard para consistência

const strategyNames = {
    'sma_cross': 'Bola Azul e Bola Vermelha',
    'digit_diff': 'NeuroFusion',
    // Adicione outras estratégias aqui no futuro
};

const BotStatsPage = () => {
    const [stats, setStats] = useState([]);
    const [loading, setLoading] = useState(true);
    const { user } = useAuth();

    useEffect(() => {
        const fetchBotStats = async () => {
            if (!user?.token) return;
            setLoading(true);
            try {
                const { data } = await api.get('/api/admin/bot-stats', {
                    headers: { Authorization: `Bearer ${user.token}` }
                });
                setStats(data);
            } catch (error) {
                toast.error("Falha ao carregar as estatísticas dos bots.");
                console.error("Erro ao buscar estatísticas dos bots:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBotStats();
    }, [user]);

    return (
        <div className="admin-page-container">
            <h1 className="admin-page-title">Estatísticas dos Bots</h1>
            <p className="admin-page-subtitle">Desempenho agregado por estratégia em contas reais.</p>

            {loading ? (
                <p>Carregando estatísticas...</p>
            ) : stats.length > 0 ? (
                // Itera sobre o array de estatísticas, criando uma seção para cada estratégia
                stats.map(strategyStats => (
                    <div key={strategyStats.strategy} className="strategy-stats-container">
                        <h2 className="admin-section-title strategy-title">
                            Estratégia: <span>{strategyNames[strategyStats.strategy] || strategyStats.strategy}</span>
                        </h2>
                        <div className="stats-grid">
                            <StatCard
                                title="Operações Totais"
                                primaryValue={strategyStats.total_operations}
                                icon={<FiRepeat />} // <<-- ADICIONA O ÍCONE
                            />
                            <StatCard
                                title="Lucro / Prejuízo Total"
                                primaryValue={`$ ${strategyStats.total_profit.toFixed(2)}`}
                                valueClassName={strategyStats.total_profit >= 0 ? 'profit' : 'loss'}
                                icon={<FiDollarSign />} // <<-- ADICIONA O ÍCONE
                            />
                            <StatCard
                                title="Clientes Únicos"
                                primaryValue={strategyStats.total_clients}
                                icon={<FiUsers />} // <<-- ADICIONA O ÍCONE
                            />
                            <StatCard
                                title="Taxa de Acerto"
                                primaryValue={`${strategyStats.win_rate.toFixed(2)}%`}
                                valueClassName={strategyStats.win_rate >= 50 ? 'profit' : 'loss'}
                                icon={<FiTarget />} // <<-- ADICIONA O ÍCONE
                            />
                        </div>
                    </div>
                ))
            ) : (
                <p>Nenhuma operação de bot encontrada em contas reais.</p>
            )}
        </div>
    );
};

export default BotStatsPage;